import { LearnerLessonType, PersonType } from "@hubcapp/types";

export const learnerLessonTypeToPersonType = (
  lessonType?: LearnerLessonType,
): PersonType => {
  switch (lessonType) {
    case LearnerLessonType.Dit:
      return PersonType.Dit;
    case LearnerLessonType.Motability:
      return PersonType.Motability;
    default:
      return PersonType.Learner;
  }
};
